var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValueOfTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 26,
    viewBox: "0 0 18 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9282 8.77551V8.59703C15.9282 6.32985 14.0903 4.49194 11.8231 4.49194H5.52527C3.15951 4.49194 1.2417 6.40976 1.2417 8.77551C1.2417 11.1413 3.15951 13.0591 5.52527 13.0591H11.6447C14.0104 13.0591 15.9282 14.9769 15.9282 17.3427C15.9282 19.7084 14.0104 21.6262 11.6447 21.6262H5.43602C3.11957 21.6262 1.2417 19.7483 1.2417 17.4319V17.3427M8.58496 2.04419V24.074",
    stroke: "white",
    strokeWidth: 2.44775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValueOfTime);
export default __webpack_public_path__ + "static/media/value-of-time.7c2d3aa1441562ea7e03195197e922bc.svg";
export { ForwardRef as ReactComponent };